import { v4 as uuidv4 } from 'uuid';
import { IAppConfig } from './config';
import CryptoJS from 'crypto-js';

export const getCodeChallenge = () => uuidv4().replace(/-/g, '');

export const decodeToken = (token: string): any | null => {
  const payload = token.split('.')[1];
  const decodedPayload = JSON.parse(atob(payload));
  return decodedPayload;
};

export const getLoginURL = (codeChallenge: string, appConfig: IAppConfig): string => {
  const { authorization_endpoint, redirect_uri, response_type, scope } = appConfig;

  if (!localStorage.getItem('CLIENT_ID')) {
    const clientId = window?.envVars?.CLIENT_ID || '';
    localStorage.setItem('CLIENT_ID', window.btoa(clientId));
  }

  let client_id = localStorage.getItem('CLIENT_ID');

  if (client_id) {
    client_id = window.atob(client_id);
  }
  
  const loginURL = `${authorization_endpoint}?client_id=${client_id}&response_type=${response_type}&redirect_uri=${redirect_uri}&scope=${scope}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

  return loginURL;
};

export const getLogoutURL = (appConfig: IAppConfig): string => {
  const { end_session_endpoint } = appConfig;

  const logoutURL = `${end_session_endpoint}?TargetResource=${window.location.origin}/logout`;

  return logoutURL;
};

export function generateCodeVerifier(): string {
  const randomString = uuidv4().replace(/-/g, '');
  return base64URLEncode(CryptoJS.enc.Utf8.parse(randomString));
}

export function getAuthCodeChallenge(codeVerifier: string): string {
  const hash = CryptoJS.SHA256(codeVerifier); 
  return base64URLEncode(hash); 
}

function base64URLEncode(str: CryptoJS.lib.WordArray): string {
  return CryptoJS.enc.Base64.stringify(str)
    .replace(/\+/g, '-') // Replace + with -
    .replace(/\//g, '_')  // Replace / with _
    .replace(/=+$/, '');  // Remove trailing '='
}
